import type { FilterSingleValue } from '..';
import { backAttribute, frontAttribute } from '..';
import notEmpty from '../../../../core/util/notEmpty';
import type {
    AttributeValueExpression,
    AttributeMatcherAndExpression,
    AttributeMatcherOrExpression,
} from '../../../types';
import useTireParams from './useTireParams';

const toAttributeFilters = (values: FilterSingleValue) => {
    return Object.entries(values)
        .filter(([, value]) => value)
        .map(([key, value]) => {
            return {
                type: 'includes',
                name: key,
                values: [value],
            };
        }) as AttributeValueExpression[];
};

const combineFilters = (children: AttributeMatcherAndExpression[]) => {
    if (children.length > 1) {
        return {
            type: 'or',
            children,
        } as AttributeMatcherOrExpression;
    } else if (children.length > 0) {
        return children[0];
    }
    return undefined;
};

const useTireAttributes = () => {
    const tierParams = useTireParams();

    const frontAttributes = toAttributeFilters(tierParams.params.front);
    const backAttributes = toAttributeFilters(tierParams.params.back);

    const frontCondition =
        frontAttributes.length > 0
            ? ({
                  type: 'and',
                  children: [frontAttribute, ...frontAttributes],
              } as AttributeMatcherAndExpression)
            : undefined;

    const backCondition =
        backAttributes.length > 0
            ? ({
                  type: 'and',
                  children: [backAttribute, ...backAttributes],
              } as AttributeMatcherAndExpression)
            : undefined;

    const children = [frontCondition, backCondition].filter(notEmpty);

    const attributeFilters = combineFilters(children);

    return { attributeFilters, frontAttributes, backAttributes };
};

export default useTireAttributes;
